<section class="mobile-bottom-sheet-wrapper">
  <div class="mobile-bottom-sheet-header">
    <p (click)="cancel()" class="mobile-bottom-sheet-header__cancel-btn" translate>Cancel</p>
    <h5 class="mobile-bottom-sheet-header__title" translate>Select Time</h5>
    <p (click)="selectTime()" class="mobile-bottom-sheet-header__action-btn" translate>Done</p>
  </div>

  <div class="mobile-bottom-sheet-content">
    <div
      [ngStyle]="{
        height: '250px',
        padding: '50px',
        display: 'flex',
        'justify-content': 'center',
        background: 'var(--white)',
      }"
    >
      <div [ngStyle]="{ width: '70px' }">
        <app-wheel-slider
          (valueSelected)="onTimeSelected($event, 'hours')"
          [initIdx]="+selectedHours"
          [length]="24"
          [previousSelectedTime]="previousSelectedTime"
          [width]="23"
          type="hours"
        ></app-wheel-slider>
      </div>
      <div [ngStyle]="{ width: '70px' }">
        <app-wheel-slider
          (valueSelected)="onTimeSelected($event, 'minutes')"
          [initIdx]="calculateInitialIndex(+selectedMinutes)"
          [intervalDifference]="15"
          [length]="4"
          [previousSelectedTime]="previousSelectedTime"
          [width]="23"
          perspective="left"
          type="minutes"
        ></app-wheel-slider>
      </div>
    </div>
  </div>
</section>
